// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SI7IS{padding:24px;text-align:start}.SI7IS.EF8_1{opacity:.4}.yjvYv{display:flex;justify-content:space-between;align-items:flex-start}.FNut1{max-inline-size:90%}.FNut1.A5Ohn{max-inline-size:80%}._jXOY{display:flex;flex-wrap:wrap;gap:12px}.qidHv{border-block-start:1px solid #eaeaef;padding-block-start:20px;display:flex;flex-direction:column;gap:4px}.qidHv .WU6I2{display:flex;align-items:flex-start}.qidHv .S8j1j{background-color:#bfbfd0;border-radius:50%;min-inline-size:4px;min-block-size:4px;margin:10px}.vtKeU{padding-block:20px;display:flex;align-items:center;justify-content:space-between}.vtKeU .qH2iz{display:flex;gap:8px;align-items:center}.vtKeU .ZDqWZ{display:flex;gap:unset;align-items:baseline}.JcwBe{display:flex}.csR8n{width:366px}.oegXG{display:flex;gap:8px;align-items:center}.y7WK6{margin-block-start:20px;border-block-start:1px solid #eaeaef;padding-block-start:20px}.y7WK6.Yyohj{border-top:0;padding-top:0}.y7WK6:empty{display:none}.f7QIK{display:flex;align-items:center;gap:8px}.MIRJA{margin-block-start:20px;border-block-start:1px solid #eaeaef;padding-block-start:20px}.dgHBL{margin-block-start:20px}.Xb3Tj{margin-top:12px;margin-bottom:12px}.Ehx9I{display:flex;flex-direction:column;align-items:flex-start;gap:8px}._wHdF{margin-block-start:8px;display:flex;align-items:center;gap:8px}._wHdF .wSY4c{padding-top:8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blue45": `#fcfcff`,
	"blue48": `#f5f7fd`,
	"blue50": `#f3f5ff`,
	"blue300": `#dae0ff`,
	"blue500": `#c0caff`,
	"blue600": `#a1aef5`,
	"blue700": `#8296ff`,
	"blue800": `#6176e7`,
	"dark50": `#fcfcfd`,
	"dark70": `#f4f4f7`,
	"dark100": `#eaeaef`,
	"dark120": `#e4e4ec`,
	"dark200": `#d4d4e0`,
	"dark300": `#bfbfd0`,
	"dark400": `#a9a9c1`,
	"dark500": `#9393b1`,
	"dark600": `#7e7ea1`,
	"dark700": `#696992`,
	"dark800": `#535382`,
	"dark900": `#282863`,
	"green45": `#eff6fa`,
	"green50": `#f3fcfa`,
	"green300": `#b6ebdf`,
	"green500": `#86ddca`,
	"green700": `#56d0b5`,
	"green800": `#36b89b`,
	"green900": `#089475`,
	"orange50": `#fdf2dc`,
	"orange300": `#fadea8`,
	"orange500": `#f9d797`,
	"orange700": `#f7ca75`,
	"orange800": `#f5bd52`,
	"orange900": `#dd9306`,
	"purple50": `#e1d9fe`,
	"purple300": `#c3b3fc`,
	"purple500": `#a58efb`,
	"purple700": `#8768f9`,
	"purple800": `#6942f8`,
	"purple900": `#4520cc`,
	"red200": `#fdf0f0`,
	"red300": `#fee3e3`,
	"red500": `#f9d5d5`,
	"red700": `#f3aaaa`,
	"red900": `#eb7272`,
	"red950": `#e86161`,
	"red970": `#dd4c4c`,
	"white": `#fff`,
	"defaultTextStandard": `#282863`,
	"defaultTextSecondary": `#696992`,
	"defaultButtonPrimary": `#6942f8`,
	"buttonPrimary": `var(--button-primary, #6942f8)`,
	"buttonPrimaryDark": `var(--button-primary-dark, #4520cc)`,
	"buttonDisabled": `var(--button-disabled, #bfbfd0)`,
	"buttonDisabledDark": `var(--button-disabled-dark, #a9a9c1)`,
	"defaultButtonDisabled": `#bfbfd0`,
	"defaultStepperCompleted": `#089475`,
	"defaultStepperIncomplete": `#d4d4e0`,
	"defaultButtonSecondary": `#fcfcfd`,
	"defaultBgStandard": `#f3f5ff`,
	"defaultBgLight": `#fff`,
	"serviceDetails": `SI7IS`,
	"original": `EF8_1`,
	"descriptionAndMenuButtonContainer": `yjvYv`,
	"detailedDescription": `FNut1`,
	"withBadge": `A5Ohn`,
	"badgesList": `_jXOY`,
	"bulletsList": `qidHv`,
	"listItem": `WU6I2`,
	"bullet": `S8j1j`,
	"finalPriceContainer": `vtKeU`,
	"price": `qH2iz`,
	"priceAndUnit": `ZDqWZ`,
	"descriptionWrapper": `JcwBe`,
	"description": `csR8n`,
	"badgeAndDotMenuContainer": `oegXG`,
	"additionalSection": `y7WK6`,
	"disableBorder": `Yyohj`,
	"startOnPauseSection": `f7QIK`,
	"addNoteContainer": `MIRJA`,
	"providedNote": `dgHBL`,
	"onApprovalWarning": `Xb3Tj`,
	"billingSettingsContainer": `Ehx9I`,
	"billingSettingsSection": `_wHdF`,
	"text": `wSY4c`
};
export default ___CSS_LOADER_EXPORT___;
